module.exports = __webpack_public_path__ + "img/logo-2.1de5d472.png";